export default __webpack_public_path__ + "static/media/user.56033033.svg";